import NetworkCall from "network/networkCall";
import Request from "network/request";

export default class EngagementRecruiters {
  static async get(params) {
    return NetworkCall.fetch(Request.v2.getEngagementRecruiters(params), false);
  }
}
